<template>
  <div>
    <ManageCollectionItemModal
      v-if="isManageCollectionItemModalShowing"
      :collectionType="collectionType"
      :itemId="itemId"
      :onClose="onCloseManageCollectionItemModal" />
    <div class="manage-collection-container"
      @click="onToggleManageCollectionItemModal">
      <div class="manage-collection-icon">
        <i class="fas fa-layer-group icon" />
      </div>
      <div class="manage-collection-header">
        <h5 class="name">
          <slot></slot>
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import ManageCollectionItemModal from './ManageCollectionItemModal.vue';

export default {
  props: {
    itemId: {
      type: String,
    },
    collectionType: {
      type: String,
    },
  },
  components: {
    ManageCollectionItemModal,
  },
  data() {
    return {
      isManageCollectionItemModalShowing: false,
    };
  },
  methods: {
    onToggleManageCollectionItemModal() {
      this.isManageCollectionItemModalShowing = !this.isManageCollectionItemModalShowing;
    },
    onCloseManageCollectionItemModal() {
      this.isManageCollectionItemModalShowing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/manage-collection-item.scss';

</style>
